import { cn } from "@/lib/utils/cn";
import { DataTableFilter } from "@/components/ui/shadcn/DataTable/DataTableFilter";
import { Input } from "@/components/ui/shadcn/Input/Input";
import { type Table } from "@tanstack/react-table";

interface DataTableFiltersToolbarProps<TData> {
  table: Table<TData>;
  filters?: {
    id: string;
    title: string;
    options: {
      label: string;
      value: string;
      icon?: React.ReactNode;
    }[];
  }[];
  hideSearchBar?: boolean;
  className?: string;
  searchInputClassName?: string;
}
export const DataTableFiltersToolbar = <TData,>({
  table,
  filters,
  hideSearchBar,
  className,
  searchInputClassName,
}: DataTableFiltersToolbarProps<TData>) => {
  const hasFilters = filters && filters.length > 0;

  if (hideSearchBar && !hasFilters) {
    return null;
  }

  return (
    <div className={cn("flex flex-wrap gap-2", className)}>
      {!hideSearchBar && (
        <Input
          placeholder="Search..."
          value={table.getState().globalFilter ?? ""}
          onChange={(e) => {
            table.setGlobalFilter(e.target.value);
            table.resetPageIndex();
          }}
          data-testid="data-table-global-search"
          className={cn("h-9 w-[150px] lg:w-[250px]", searchInputClassName)}
        />
      )}
      {filters?.map((filter) => (
        <DataTableFilter
          key={filter.id}
          title={filter.title}
          options={filter.options}
          column={table.getColumn(filter.id)}
        />
      ))}
    </div>
  );
};
